import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  border: 1px solid black;
  margin-bottom: 1em;
  > :nth-child(2n) {
    background-color: #cbcbcb;
  }
  > :nth-child(2n+1) {
    background-color: #bebebe;
  }
  > :first-child {
    background-color: grey;
  }
`
const Header = styled.div`
  font-weight: bold;
  padding: 0.25em;
`
const Row = styled.div`
  padding: 0.25em;
  ${({ disabled }) => disabled && `
    color: lightgrey;
    font-style: italic;
  `};
`

export default function TextTable({
  displayDisabled,
  heading,
  rows,
  component: Component = 'span',
  noRowsMsg = 'No rows to display.',
}) {
  const elements = rows.map(({ disabled, ...row }, i) => {
    if (!displayDisabled && disabled) {
      return null
    }
    return (
      <Row key={i} disabled={disabled}>
        <Component>
          {row}
        </Component>
      </Row>
    )
  })
  return (
    <Container>
      <Header>
        {heading}
      </Header>
      {elements.every(ele => ele == null) ? <div>{noRowsMsg}</div> : elements}
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/components/TextTable.js